
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContextMessageNodeLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoreNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NodeBasicFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContextMessageNodeParent"},"directives":[]}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("../nodes/NodeBasicFields.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ContextMessageNodeParent.fragment.graphql").definitions));


    module.exports = doc
  
